import { isValidFederalId } from '../../utils';

export function getErrorMessage(value) {
  const cleaned = value.replace(/[^\d]+/g, '');
  if (cleaned.length === 14 && !isValidFederalId(value)) {
    return 'O CNPJ informado não é válido. Confira o número e tente novamente.';
  }

  return false;
}
